const colors = {
  primary: '#ff6343', // Color for buttons or links
  secondary: '#ffe6e1',
  bg: '#fff', // Background color
  white: '#fff',
  grey: {
    dark: '#212529',
    default: '#6c757d',
    tint: '#C4C7CB',
    transparent: 'rgba(0, 0, 0, 0.2)',
    light: '#edeff1',
    ultraLight: '#f8f9fa',
  },
};

const transitions = {
  normal: '320s',
  quick: '180ms',
};

const fontSize = {
  small: '.75rem',
  big: '2.5rem',
};

export default {
  colors,
  transitions,
  fontSize,
};
